import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { RequestService, ExperimentCreationModel, AssignmentNotes, CeLogistics, OriginatingSystem } from '../../shared/services/request.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { AlertService } from '../../shared/services/alert.service';
import { TacticalLiaisonService, TacticalLiaison } from '../../shared/services/tactical-liaison.service';
import { Observable } from 'rxjs';
import { ViewableRequest } from '../review-request/review-request.model';
import { AoiService, Aoi } from '../../shared/services/aoi.service';
import { FacilityTypeService, FacilityType } from '../../shared/services/facility-type.service';
import { CreateExperimentModalComponent } from '../create-experiment-modal/create-experiment-modal.component';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { finalize, mergeMap } from "rxjs/operators";
import { asEnumerable } from "linq-es2015";
import { FileSaverService } from '../../shared/services/file-saver.service';
import { RequestAssignmentModalComponent } from '../request-assignment-modal/request-assignment-modal.component';
import { RequestPlanningModalComponent } from '../request-planning-modal/request-planning-modal.component';
import { RequestReviewModalComponent } from '../request-review-modal/request-review-modal.component';
import { RequestStatusEnum } from '../../shared/services/request-status.service';
import { RequestRejectionModalComponent } from '../request-rejection-modal/request-rejection-modal.component';
import { Router } from '@angular/router';
import { ConfirmationModalComponent } from '../../shared/components/confirmation-modal/confirmation-modal.component';
import { UserRoles } from '../../shared/services/current-user.service';
import { RequestCommentsService, RequestCommentSubmission } from '../../shared/services/request-comments.service';
import { AssignmentWithComments } from '../request-assignment-modal/request-assignment-modal.component';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { PlanningService, PlanningInformation } from '../../shared/services/planning.service';
import { LaboratoryService, Laboratory } from '../../shared/services/laboratory.service';
import { GrowthStageService, GrowthStage } from '../../shared/services/growth-stage.service';
import { TissueTypeService, TissueType } from '../../shared/services/tissue-type.service';
import { map } from 'rxjs/operators';
import { ReAssignmentModel, RequestReAssignmentModalComponent } from '../request-reassignment-modal/request-reassignment-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { RequestType, RequestTypeService } from '../../shared/services/request-type.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-request-action-toolbar',
  styleUrls: ['./request-action-toolbar.component.css'],
  templateUrl: './request-action-toolbar.component.html'
})
export class RequestActionToolbarComponent implements OnInit {

  @Input() request: ViewableRequest;
  @Input() isWheatRequest: boolean;
  
  @Output() statusChanged: EventEmitter<any> = new EventEmitter();
  @Output() saved: EventEmitter<any> = new EventEmitter();

  public copyRoles: UserRoles = UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator;
  public rejectRoles: UserRoles = UserRoles.CollaboratorLiaison;
  public assignRoles: UserRoles = UserRoles.CollaboratorLiaison;
  public planRoles: UserRoles = UserRoles.TacticalLiaison;
  public reviewRoles: UserRoles = UserRoles.CollaboratorLiaison;
  public createExperimentRoles: UserRoles = UserRoles.ExperimentCreator;
  public exportEuidRoles: UserRoles = UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator;
  public printPlantingCardRoles: UserRoles = UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator;
  public cancelRoles: UserRoles = UserRoles.CollaboratorLiaison;
  public reAssignRoles: UserRoles = UserRoles.CollaboratorLiaison;
  public donorRequestRoles: UserRoles = UserRoles.TacticalLiaison;

  public rejectButtonStatuses: RequestStatusEnum[] = [RequestStatusEnum.Submitted, RequestStatusEnum.Assigned, RequestStatusEnum.ReadyForReview];
  public assignButtonStatuses: RequestStatusEnum[] = [RequestStatusEnum.Submitted];
  public planButtonStatuses: RequestStatusEnum[] = [RequestStatusEnum.Assigned];
  public reviewButtonStatuses: RequestStatusEnum[] = [RequestStatusEnum.ReadyForReview];
  public createExperimentButtonStatuses: RequestStatusEnum[] = [RequestStatusEnum.Reviewed];
  public exportButtonStatuses: RequestStatusEnum[] = [RequestStatusEnum.ExperimentInProgress, RequestStatusEnum.Pollination, RequestStatusEnum.Harvest, RequestStatusEnum.PlantedInFlat];
  public printPlantingCardButtonStatuses: RequestStatusEnum[] = [ RequestStatusEnum.ReadyForReview, RequestStatusEnum.Reviewed, RequestStatusEnum.CreatingExperiment, RequestStatusEnum.ExperimentInProgress, RequestStatusEnum.Pollination, RequestStatusEnum.Harvest, RequestStatusEnum.PlantedInFlat];
  public cancelButtonStatuses: RequestStatusEnum[] = [RequestStatusEnum.Draft, RequestStatusEnum.Submitted, RequestStatusEnum.Assigned,
    RequestStatusEnum.ReadyForReview, RequestStatusEnum.Reviewed, RequestStatusEnum.CreatingExperiment, RequestStatusEnum.ExperimentInProgress,
    RequestStatusEnum.ExperimentCompleted, RequestStatusEnum.ExperimentCreationError ];
  public reAssignButtonStatuses: RequestStatusEnum[] = [ RequestStatusEnum.Assigned, RequestStatusEnum.ReadyForReview, RequestStatusEnum.Reviewed ];

  public get isTnRequest(): boolean {
    return this.request.originatingSystem === OriginatingSystem.MyCE;
  }

  public get isDonorNeeded(): boolean {
    return (this.request.pollinationInstructions) ? this.request.pollinationInstructions.donorsNeeded : false;
  }

  constructor(
    private modalService: BsModalService,
    private requestService: RequestService,
    private planningService: PlanningService,
    private alertService: AlertService,
    private tacticalLiaisonService: TacticalLiaisonService,
    private aoiService: AoiService,
    private facilityTypeService: FacilityTypeService,
    private loadingService: LoadingWrapperService,
    private fileSaverService: FileSaverService,
    private requestCommentsService: RequestCommentsService,
    private router: Router,
    private labService: LaboratoryService,
    private growthStageService: GrowthStageService,
    private tissueTypeService: TissueTypeService,
    private requestTypeService: RequestTypeService,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() { }

  public showRejectionModal(): void {
    this.openRejectionModal();
  }
  
  public showAssignmentModal(): void {
      this.getActiveTacticalLiaisons()
        .subscribe(activeTacticalLiaisons => this.openAssignmentModalWithLiaisons(activeTacticalLiaisons));
  }

  public showReAssignmentModal(): void {
    forkJoin(this.getActiveTacticalLiaisons(), this.requestService.getCeLogistics(this.request.id))
      .subscribe(([tacticalLiaisons, ceLogistics])=> this.openReAssignmentModalWithLiaisons(tacticalLiaisons, ceLogistics.tacticalLiaisonId));
  }

  public showPlanningModal(): void {
    Observable.forkJoin(
      this.planningService.getPlanningNotes(this.request.id),
      this.labService.getAll(),
      this.growthStageService.getAll(),
      this.tissueTypeService.getAll(),
      this.requestTypeService.getAll()
    ).subscribe(([
        planningNotes,
        labs,
        growthStages,
        tissueTypes,
        requestTypes]) => 
    {
      this.openPlanningModalWithData(
        planningNotes, 
        {
          labs: labs,
          growthStages: growthStages,
          tissueTypes: tissueTypes,
          requestTypes: requestTypes
        });
    });
  }

  public showReviewModal(): void {
    this.openReviewModal();
  }

  public showExperimentCreationModal(): void {
    this.loadingService.setMessage("Loading experiment creation options...");

    Observable.forkJoin(
      this.facilityTypeService.getAll(),
      this.aoiService.getAll(),
      this.requestService.getDetails(this.request.id),
      this.requestService.getCeLogistics(this.request.id),
      this.planningService.getPlanningNotes(this.request.id)
    ).subscribe(([
      facilityTypes,
      aois,
      requestDetails,
      ceLogistics,
      planningNotes
    ]) => {
      this.loadingService.clearMessage();
      this.openExperimentCreationModalWithData(facilityTypes, aois, requestDetails.cropId, ceLogistics,planningNotes);
    })
  }

  public printPlantingCard(): void {
    this.loadingService.setMessage("Printing Planting Card...");

    this.requestService.getPlantingCards([ this.request.id ])
      .pipe(finalize(()=> this.loadingService.clearMessage()))
      .subscribe(
        (plantingCardFile) => {
          this.fileSaverService.save(plantingCardFile);
          this.alertService.success("Planting Card Download Complete!");
        },
        (errorResponse: HttpErrorResponse) => {
          this.alertService.error(`Error retreiving Planting Card. ${errorResponse.error}.`);
        }
      );
  }

  public cloneRequest(): void {
    this.openCloningConfirmationModal();
  }

  public createDonorRequest(): void {
    this.openDonorRequestConfirmationModal();
  }

  public exportEuids(): void {
    this.requestService.getPlantFile(this.request.id)
      .subscribe(
      (f) => {
        if (f) {
          this.fileSaverService.save(f);
          this.alertService.success('Exporting EUIDs complete!');
        } else {
          this.alertService.error('Error exporting EUIDs'); 
        } 
      },
      () => this.alertService.error('Error exporting EUIDs')
    )
  }

  public cancelRequest(): void {
    this.openCancelConfirmationModal();
  }

  private getActiveTacticalLiaisons(): Observable<TacticalLiaison[]> {
    return this.tacticalLiaisonService.get()
      .pipe(
        map(tacticalLiaisons => {
            const liaisonList = asEnumerable(tacticalLiaisons || []);
            return liaisonList
              .Where(l => l.isActive)
              .OrderBy(l => l.surname)
              .ThenBy(l => l.givenName)
              .ToArray();
        })
      );
  }

  private openRejectionModal() {
    const modalOptions: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      initialState: {
        request: this.request
      }
    };

    const modal = this.modalService.show(RequestRejectionModalComponent, modalOptions);
    const component = <RequestRejectionModalComponent>modal.content;

    component
      .onRejected
      .subscribe((comments: RequestCommentSubmission) => {
        this.requestCommentsService.save(comments)
          .catch((e) => {
              this.alertService.error('Error saving notes');
              return Observable.throw(e);
            })
          .pipe(mergeMap(() => this.requestService.rejectRequest(this.request.id)))
          .subscribe(
            () => {
              component.onRejected.unsubscribe();
              component.onBackToPlanning.unsubscribe();
              component.onClose.unsubscribe();
              modal.hide();
              this.alertService.success('Rejected');
              this.statusChanged.emit(null);
            },
            () => this.alertService.error('Error rejecting request...'));
    });

    component
    .onBackToPlanning
    .subscribe((comments: RequestCommentSubmission) => {
      this.requestCommentsService.save(comments)
        .catch((e) => {
          this.alertService.error('Error saving notes');
          return Observable.throw(e);
        })
        .pipe(mergeMap(() => this.requestService.sendBackToPlanning(this.request.id)))
        .subscribe(
          () => {
            component.onRejected.unsubscribe();
            component.onBackToPlanning.unsubscribe();
            component.onClose.unsubscribe();
            modal.hide();
            this.alertService.success('Sent back to planning');
            this.statusChanged.emit(null);
          },
          () => this.alertService.error('Error sending back to planning...'));
    });

    component
      .onClose
      .subscribe(() => {
        component.onRejected.unsubscribe();
        component.onBackToPlanning.unsubscribe();
        component.onClose.unsubscribe();
        modal.hide();
    });
  }

  private openAssignmentModalWithLiaisons(activeTacticalLiaisons: TacticalLiaison[]) {
    const modalOptions: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      initialState: {
        request: this.request,
        tacticalLiaisons: activeTacticalLiaisons
      }
    };

    const modal = this.modalService.show(RequestAssignmentModalComponent, modalOptions);
    const component = <RequestAssignmentModalComponent>modal.content;

    component
      .onAssigned
      .subscribe((assignmentWithComments: AssignmentWithComments) => {
          this.saveAssignmentsWithComments(modal, component, assignmentWithComments);
      });

      component
        .onClose
        .subscribe(() => {
          component.onAssigned.unsubscribe();
          component.onClose.unsubscribe();
          modal.hide();
        });
  }

  private saveAssignmentsWithComments(modal: BsModalRef, component: RequestAssignmentModalComponent, assignmentWithComments: AssignmentWithComments) {
    let assignment: AssignmentNotes = {
      tacticalLiaisonId: assignmentWithComments.tacticalLiaisonId,
      id: assignmentWithComments.id
    };

    let comments: RequestCommentSubmission ={
      requestId: assignmentWithComments.id,
      comment: assignmentWithComments.comment,
      source: assignmentWithComments.source
    };

    forkJoin(
      this.requestCommentsService.save(comments)
      .catch((e) => {
        this.alertService.error('Error saving notes');
        return Observable.throw(e);
      }),
      this.requestService.saveAssignmentNotes(assignment)
      .catch((e) => {
        this.alertService.error('Error saving assignment details')
        return Observable.throw(e);
      })
    ).subscribe(() => 
      {
        this.requestService.assignRequest(assignmentWithComments.id)
          .subscribe(
            () => {
              component.onAssigned.unsubscribe();
              component.onClose.unsubscribe();
              modal.hide();
              this.alertService.success('Assigned!');
              this.statusChanged.emit(null);
            },
            () => {
              this.alertService.error('Failed to set status to assigned. Please contact support'); 
            }
          )
      }
    );
  }

  private openReAssignmentModalWithLiaisons(activeTacticalLiaisons: TacticalLiaison[], initialTacticalLiaisonId: number) {
    const modalOptions: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      initialState: {
        request: this.request,
        tacticalLiaisons: activeTacticalLiaisons,
        initialTacticalLiaisonId
      }
    };

    const modal = this.modalService.show(RequestReAssignmentModalComponent, modalOptions);
    const component = <RequestReAssignmentModalComponent>modal.content;

    component
      .onReAssigned
      .subscribe((reAassignment: ReAssignmentModel) => {
          this.reAssignRequest(modal, component, reAassignment.requestId, reAassignment.tacticalLiaisonId);
      });

      component
        .onClose
        .subscribe(() => {
          component.onReAssigned.unsubscribe();
          component.onClose.unsubscribe();
          modal.hide();
        });
  }


  private reAssignRequest(modal: BsModalRef, component: RequestReAssignmentModalComponent, requestId: number, tacticalLiaisonUserId: number) {
    this.requestService.reAssignRequest(requestId, tacticalLiaisonUserId).subscribe(
      () => {
        component.onReAssigned.unsubscribe();
        component.onClose.unsubscribe();
        modal.hide();
        this.alertService.success('Re-assigned!');
        this.statusChanged.emit(null);
      },
      (error) => {
        this.alertService.error(`Error re-assigning Tactial Liaison to Request. Please contact support`);
        console.log(error);
      }
    );
  }

  private openPlanningModalWithData(
    savedData: PlanningInformation, 
    options: {
      labs: Laboratory[],
      growthStages: GrowthStage[],
      tissueTypes: TissueType[],
      requestTypes: RequestType[]
    })
  {
    const availableRequestTypes = asEnumerable(options.requestTypes || []);

    const activeRequestTypes = availableRequestTypes
      .Where(a => a.isActive)
      .OrderBy(a => a.order)
      .ToArray();


    const modalOptions: ModalOptions = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'custom-modal-lg',
      initialState: {
        request: this.request,
        isWheatRequest: this.isWheatRequest,
        labs: asEnumerable(options.labs),
        growthStages: asEnumerable(options.growthStages),
        tissueTypes: asEnumerable(options.tissueTypes),
        planningInformation: savedData,
        requestTypes: activeRequestTypes
      }
    };

    let modalInstance = this.modalService.show(RequestPlanningModalComponent, modalOptions);
    let component = <RequestPlanningModalComponent>modalInstance.content;

    component.onSave
      .subscribe((n: PlanningInformation) => {
        this.planningService
          .savePlanningNotes(n)
          .subscribe(
            () => {
               this.alertService.success('Saved request planning notes...');
               this.saved.emit(null);
            },
            () => this.alertService.error('Error saving request planning notes...')
          );
      });

    component.onPlanned
      .subscribe((n: PlanningInformation) => {
        this.planningService
          .savePlanningNotes(n)
          .switchMap(d => this.requestService.completeRequestPlan(this.request.id))
          .subscribe(
            () => {
              component.onSave.unsubscribe();
              component.onPlanned.unsubscribe();
              component.onClose.unsubscribe();
              modalInstance.hide();
              this.alertService.success('Request plan complete!');
              this.statusChanged.emit(null);
            }, 
            () => this.alertService.error('Error completing request plan'));
      });

    component.onClose
      .subscribe(() => {
        component.onSave.unsubscribe();
        component.onPlanned.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });
  }

  private openReviewModal() {
    const modalOptions: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      initialState: {
        request: this.request
      }
    };

    const modal = this.modalService.show(RequestReviewModalComponent, modalOptions);
    const component = <RequestReviewModalComponent>modal.content;

    component
      .onReviewed
      .subscribe((comments: RequestCommentSubmission) => {
        this.requestCommentsService.save(comments)
          .catch(((e) => 
          {
              this.alertService.error('Error saving notes');
              return Observable.throw(e);
          }))
          .pipe(
            mergeMap(
              () => this.requestService.completeRequestReview(this.request.id)))
          .subscribe(
            () => {
              component.onReviewed.unsubscribe();
              component.onClose.unsubscribe();
              modal.hide();
              this.alertService.success('Review complete!'); 
              this.statusChanged.emit(null);
            },
            () => this.alertService.error('Error completing review...')
          );
      });

      component
        .onClose
        .subscribe(() => {
          component.onReviewed.unsubscribe();
          component.onClose.unsubscribe();
          modal.hide();
        });
  }

  private openExperimentCreationModalWithData(facilityTypes: FacilityType[], aois: Aoi[], cropId: number, ceLogistics: CeLogistics, planningNotes: PlanningInformation) {
    const availableFacilityTypes = asEnumerable(facilityTypes || []);
    const availableAois = asEnumerable(aois || []);
    const activeFacilityTypes = availableFacilityTypes
      .Where(f => f.isActive)
      .OrderBy(f => f.order)
      .ToArray();

    const activeAois = availableAois
      .Where(a => a.isActive)
      .Where(a => a.cropId === cropId)
      .OrderBy(a => a.name)
      .ToArray();

    const initialState = {
      aois: activeAois,
      facilities: activeFacilityTypes,
      request: this.request,
      ceLogistics: ceLogistics,
      planningNotes:planningNotes
    }

    const modalOptions: ModalOptions = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      initialState: initialState
    };

    let modalInstance = this.modalService.show(CreateExperimentModalComponent, modalOptions);
    let component = <CreateExperimentModalComponent>modalInstance.content;

    component.onCreateExperiment
      .subscribe((experimentCreationDetails: ExperimentCreationModel) => {
        this.loadingService.setMessage("Creating experiment...");
        this.requestService.saveExperimentCreationDetails(experimentCreationDetails)
        .switchMap(d => this.requestService.createExperiment(this.request.id))  
        .pipe(finalize(() => this.loadingService.clearMessage()))       
        .subscribe(
          () => {
            component.onCreateExperiment.unsubscribe();
            component.onClose.unsubscribe();
            this.alertService.success('Sent for experiment creation!')
            modalInstance.hide();
            this.statusChanged.emit(null);
          },
          () => this.alertService.error('Error creating experiment')
        )
      });
    

    component.onClose
      .subscribe(() => {
        component.onCreateExperiment.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });
  }

  private openCloningConfirmationModal() {
    const modalOptions: any = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-md',
      initialState: {
        title: 'Please confirm',
        body: `Are you sure you want to copy request "${this.request.title}"?`
      }
    };

    const modalInstance = this.modalService.show(ConfirmationModalComponent, modalOptions);
    const component = <ConfirmationModalComponent>modalInstance.content;

    component
      .onConfirm
      .subscribe(() => {
        modalInstance.hide();

        this.loadingService.setMessage(`Creating copy of ${this.request.title}`);

        this.requestService
              .cloneRequest(this.request.id)
              .subscribe(
                r => {
                  component.onConfirm.unsubscribe();
                  component.onCancel.unsubscribe();
                  component.onClose.unsubscribe();
                  modalInstance.hide();
                  this.router.navigate([`/requests/edit/${r.id}`]);
                },
                e => {
                  this.loadingService.clearMessage();
                  this.alertService.error(`Error copying request ${this.request.title}`);
                }
              );
      });

    component
      .onCancel
      .subscribe(() => {
        component.onConfirm.unsubscribe();
        component.onCancel.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });

    component
      .onClose
      .subscribe(() => {
        component.onConfirm.unsubscribe();
        component.onCancel.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });
  }

  private openDonorRequestConfirmationModal() {
    const modalOptions: any = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-md',
      initialState: {
        title: 'Please confirm',
        body: `Are you sure you want to create a donor request for "${this.request.title}"?`
      }
    };

    const modalInstance = this.modalService.show(ConfirmationModalComponent, modalOptions);
    const component = <ConfirmationModalComponent>modalInstance.content;

    component
      .onConfirm
      .subscribe(() => {
        modalInstance.hide();

        this.loadingService.setMessage(`Creating donor request for ${this.request.title}`);

        this.requestService
          .createDonorRequest(this.request.id)
          .subscribe(
            r => {
              component.onConfirm.unsubscribe();
              component.onCancel.unsubscribe();
              component.onClose.unsubscribe();
              modalInstance.hide();
              let baseHref = this.document.querySelector('base').getAttribute('href');
              if (!baseHref.startsWith('/')) {
                baseHref = '/' + baseHref;
              }
              baseHref = baseHref.replace(/\/$/, '');
              const tree = this.router.createUrlTree([`/requests/edit/${r.id}`]);
              let relativeUrl = this.router.serializeUrl(tree);
              relativeUrl = relativeUrl.replace(/^\/+/, '');
              const url = `${window.location.origin}${baseHref}/${relativeUrl}`;
              window.open(url, '_blank');
              this.loadingService.clearMessage();
            },
            e => {
              this.loadingService.clearMessage();
              this.alertService.error(`Error creating donor request for ${this.request.title}`);
            }
          );
      });

    component
      .onCancel
      .subscribe(() => {
        component.onConfirm.unsubscribe();
        component.onCancel.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });

    component
      .onClose
      .subscribe(() => {
        component.onConfirm.unsubscribe();
        component.onCancel.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });
  }

  private openCancelConfirmationModal() {
    const modalOptions: any = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-md',
      initialState: {
        title: 'Please confirm',
        body: `Are you sure you want to cancel request "${this.request.title}"?`
      }
    };

    const modalInstance = this.modalService.show(ConfirmationModalComponent, modalOptions);
    const component = <ConfirmationModalComponent>modalInstance.content;

    component
      .onConfirm
      .subscribe(() => {
        modalInstance.hide();

        this.loadingService.setMessage(`Cancelling request ${this.request.title}`);

        this.requestService
              .cancelRequest(this.request.id)
              .pipe(finalize(() => this.loadingService.clearMessage()))    
              .subscribe(
                r => {
                  component.onConfirm.unsubscribe();
                  component.onCancel.unsubscribe();
                  component.onClose.unsubscribe();
                  this.alertService.success(`Request ${this.request.title} has been cancelled`);
                  this.statusChanged.emit(null);
                },
                e => {
                  this.alertService.error(`Error cancelling request ${this.request.title}`);
                }
              );
      });

    component
      .onCancel
      .subscribe(() => {
        component.onConfirm.unsubscribe();
        component.onCancel.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });

    component
      .onClose
      .subscribe(() => {
        component.onConfirm.unsubscribe();
        component.onCancel.unsubscribe();
        component.onClose.unsubscribe();
        modalInstance.hide();
      });
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-action-toolbar/request-action-toolbar.component.ts